import React from "react";

const MicroClient = ({ clientName }) => {
  const MicroComponent = React.lazy(() => import(`../${clientName}`));

  return <MicroComponent />;
};
export default MicroClient;
